import ReducerRegistry from '../base/redux/ReducerRegistry';

import {
    CLOSE_BREAKOUT_ROOM_MODAL,
    OPEN_BREAKOUT_ROOM_MODAL,
    SET_PERSISTENT_BREAKOUT_AUTO_ASSIGN,
    UPDATE_BREAKOUT_ROOMS,
    _RESET_BREAKOUT_ROOMS,
    _UPDATE_ROOM_COUNTER
} from './actionTypes';
import { FEATURE_KEY } from './constants';

const DEFAULT_STATE = {
    rooms: {},
    roomCounter: 0,

    // The server's room counter from its last update; roomCounter runs ahead
    // of it by the creations it has not processed yet.
    serverRoomCounter: 0,
    isBreakoutRoomModalOpen: false,
    persistentAutoAssign: false
};


/**
 * Listen for actions for the breakout-rooms feature.
 */
ReducerRegistry.register(FEATURE_KEY, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case _UPDATE_ROOM_COUNTER:
        return {
            ...state,
            roomCounter: action.roomCounter
        };
    case UPDATE_BREAKOUT_ROOMS: {
        const { roomCounter, rooms, updatedNames } = action;

        // A local display-name edit re-dispatches the rooms with the local
        // counter; only the server's update says what it has processed.
        if (updatedNames) {
            return {
                ...state,
                rooms
            };
        }

        const serverRoomCounter = roomCounter ?? 0;

        return {
            ...state,

            // Keep the local count when ahead: an update can be sent before
            // the server has processed a creation that is already on its way.
            roomCounter: Math.max(state.roomCounter, serverRoomCounter),
            serverRoomCounter,
            rooms
        };
    }
    case _RESET_BREAKOUT_ROOMS: {
        return DEFAULT_STATE;
    }
    case OPEN_BREAKOUT_ROOM_MODAL:
        return {
            ...state,
            isBreakoutRoomModalOpen: true
        };
    case CLOSE_BREAKOUT_ROOM_MODAL:
        return {
            ...state,
            isBreakoutRoomModalOpen: false
        };
    case SET_PERSISTENT_BREAKOUT_AUTO_ASSIGN:
        return {
            ...state,
            persistentAutoAssign: action.persistent
        };
    }

    return state;
});
